(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["saltwater-club-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const root = document.getElementById('sw-club-popup');
    if (!root || root.dataset.swReady || window.Shopify?.designMode || document.querySelector('[data-sw-club]')) return;
    root.dataset.swReady = 'true';
    const dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const STORAGE_KEY = 'saltwater:club-popup:dismissed-at:v1';
    const WEEK = 7 * 24 * 60 * 60 * 1000;
    const DELAY = 12000;
    const LOCK_CLASS = 'sw-club-popup-lock';
    const BLOCKERS = [
      'dialog[open]', '[role="dialog"]', '[aria-modal="true"]',
      '.js-slideout-overlay.site-overlay', '.js-modal-overlay.site-overlay',
      '#slideout-mobile-navigation', '#slideout-ajax-cart', '#slideout-search-sidebar',
      '#modal-ajax-cart', '#modal-quickview-cart', '.pswp[aria-hidden="false"]',
      '.joy-widget-container', '[data-sw-popup-blocker]',
      '.shopify-pc__banner__dialog', '#shopify-pc__banner', '#onetrust-banner-sdk',
      '#CybotCookiebotDialog', '.cc-window:not(.cc-invisible)',
      '[data-testid="cookie-banner"]', '.cookie-consent-banner',
      '[data-cookie-banner]', '[data-consent-banner]'
    ].join(',');
    let storage;
    let finished = false;
    let displayed = false;
    let timer;
    let previousFocus;
    let previousScroll;
    let ownsScrollLock = false;
    let observer;
    const observedRoots = new WeakSet();
    let auditQueued = false;

    const routeIsBlocked = () => {
      const type = root.dataset.pageType || '';
      const path = window.location.pathname;
      return /^(?:customers\/|cart$|checkout$|password$|captcha$)/.test(type) ||
        /(?:^|\/)(?:account|accounts|cart|checkout|checkouts)(?:\/|$)/i.test(path) ||
        new URLSearchParams(window.location.search).has('open_joy');
    };
    const readCooldown = () => {
      try {
        const raw = storage.getItem(STORAGE_KEY);
        if (raw === null) return false;
        const value = Number(raw);
        return !Number.isFinite(value) || value <= 0 || Date.now() - value < WEEK;
      } catch (_) {
        return true;
      }
    };
    const canPersist = () => {
      try {
        const key = STORAGE_KEY + ':probe';
        storage.setItem(key, '1');
        const ok = storage.getItem(key) === '1';
        storage.removeItem(key);
        return ok;
      } catch (_) {
        return false;
      }
    };
    try {
      storage = window.localStorage;
      if (routeIsBlocked() || readCooldown() || !canPersist()) return;
    } catch (_) {
      return;
    }

    const composedParent = (element) => element.parentElement || element.getRootNode().host;
    const visible = (element) => {
      if (root.contains(element) || element === root) return false;
      if (element.tagName === 'DIALOG' && !element.open) return false;
      for (let node = element; node; node = composedParent(node)) {
        if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
        const style = getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.opacity === '0') return false;
      }
      const rect = element.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
      const viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 &&
        rect.top < viewportHeight && rect.left < viewportWidth;
    };
    const getRoots = () => {
      const roots = [document];
      for (let index = 0; index < roots.length; index += 1) {
        roots[index].querySelectorAll('*').forEach((element) => {
          if (element.shadowRoot) roots.push(element.shadowRoot);
        });
      }
      return roots;
    };
    const hasCompetition = () => {
      if (document.querySelector('body.slideout-left--open,body.slideout-right--open,html.slideout-left--open,html.slideout-right--open')) return true;
      return getRoots().some((scope) => Array.from(scope.querySelectorAll(BLOCKERS)).some(visible));
    };
    const stop = () => {
      finished = true;
      clearTimeout(timer);
      if (observer) observer.disconnect();
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('pagehide', onPageHide);
    };
    const restore = (restoreFocus) => {
      if (ownsScrollLock) document.documentElement.classList.remove(LOCK_CLASS);
      ownsScrollLock = false;
      if (restoreFocus && previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') {
        previousFocus.focus({preventScroll: true});
      }
      if (restoreFocus && previousScroll) window.scrollTo(previousScroll.x, previousScroll.y);
    };
    const finish = (persist, restoreFocus) => {
      if (finished) return;
      stop();
      if (persist && displayed) {
        try { storage.setItem(STORAGE_KEY, String(Date.now())); } catch (_) {}
      }
      if (dialog.open) dialog.close();
      restore(restoreFocus);
    };
    const onStorage = (event) => {
      if (event.key === STORAGE_KEY && readCooldown()) finish(false, false);
    };
    const onPageHide = () => finish(dialog.open, false);
    const audit = () => {
      auditQueued = false;
      if (finished) return;
      if (!root.isConnected || routeIsBlocked() || readCooldown()) {
        finish(false, false);
        return;
      }
      if (dialog.open && hasCompetition()) finish(false, false);
    };
    const watch = () => {
      if (!observer && typeof MutationObserver === 'function') {
        observer = new MutationObserver(() => {
          if (!auditQueued && !finished) {
            auditQueued = true;
            queueMicrotask(audit);
          }
        });
      }
      if (!observer) return;
      getRoots().forEach((scope) => {
        if (observedRoots.has(scope)) return;
        observedRoots.add(scope);
        observer.observe(scope, {subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'class', 'style', 'hidden', 'aria-hidden', 'aria-modal']});
      });
    };
    const tick = () => {
      if (finished) return;
      if (!root.isConnected || routeIsBlocked() || readCooldown()) {
        finish(false, false);
        return;
      }
      const competing = hasCompetition();
      if (dialog.open) {
        if (competing) { finish(false, false); return; }
        watch();
      } else if (!displayed && document.visibilityState === 'visible' && !competing) {
        if (!canPersist()) { finish(false, false); return; }
        previousFocus = document.activeElement;
        previousScroll = {x: window.scrollX, y: window.scrollY};
        try {
          dialog.showModal();
        } catch (_) {
          finish(false, false);
          return;
        }
        displayed = true;
        ownsScrollLock = !document.documentElement.classList.contains(LOCK_CLASS);
        document.documentElement.classList.add(LOCK_CLASS);
        dialog.querySelector('[data-sw-close]').focus({preventScroll: true});
        watch();
      }
      timer = setTimeout(tick, 500);
    };

    root.querySelectorAll('[data-sw-close]').forEach((button) => button.addEventListener('click', () => finish(true, true)));
    root.querySelectorAll('[data-sw-cta]').forEach((link) => {
      link.addEventListener('click', () => finish(true, false));
      link.addEventListener('auxclick', (event) => { if (event.button === 1) finish(true, true); });
    });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); finish(true, true); });
    dialog.addEventListener('close', () => finish(true, true));
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) finish(true, true);
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const items = Array.from(dialog.querySelectorAll('a[href],button:not([disabled])'));
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.addEventListener('storage', onStorage);
    window.addEventListener('pagehide', onPageHide);
    timer = setTimeout(tick, DELAY);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
